/**
 * Localizes the visible Optionize custom-option labels on storefront product pages.
 * It intentionally does not change input names, values, or app data attributes so
 * Optionize can keep handling the order data normally.
 */
(() => {
  const localeFromPath = () => {
    const language = document.documentElement.lang?.toLowerCase().split('-')[0];
    if (language === 'de' || language === 'ja') return language;

    const pathLocale = window.location.pathname.match(/^\/(de|ja)(?:\/|$)/i)?.[1]?.toLowerCase();
    return pathLocale || 'en';
  };

  const translations = {
    de: {
      text: {
        'Personalize with your pet’s name': 'Personalisieren Sie mit dem Namen Ihres Haustiers',
        "Personalize with your pet's name": 'Personalisieren Sie mit dem Namen Ihres Haustiers',
        'Up to 20 characters': 'Bis zu 20 Zeichen',
      },
      placeholder: {
        'Enter your pet’s name': 'Name Ihres Haustiers eingeben',
        "Enter your pet's name": 'Name Ihres Haustiers eingeben',
      },
    },
    ja: {
      text: {
        'Personalize with your pet’s name': 'ペットのお名前を入れる',
        "Personalize with your pet's name": 'ペットのお名前を入れる',
        'Up to 20 characters': '最大20文字',
      },
      placeholder: {
        'Enter your pet’s name': 'ペットのお名前を入力',
        "Enter your pet's name": 'ペットのお名前を入力',
      },
    },
  };

  const dictionary = translations[localeFromPath()];
  if (!dictionary) return;

  const normalize = (value) => value.replace(/\s+/g, ' ').trim();

  const replaceText = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const source = normalize(node.nodeValue || '');
      const translation = dictionary.text[source];
      if (translation) node.nodeValue = (node.nodeValue || '').replace(source, translation);
    });
  };

  const localize = () => {
    // Optionize can render without a stable wrapper class on the free plan.
    // The dictionary uses exact strings, so scanning the page remains narrowly scoped.
    replaceText(document.body);
    document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((field) => {
      const translation = dictionary.placeholder[normalize(field.getAttribute('placeholder') || '')];
      if (translation) field.setAttribute('placeholder', translation);
    });
  };

  let frame;
  const scheduleLocalization = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(localize);
  };

  document.addEventListener('DOMContentLoaded', () => {
    scheduleLocalization();
    new MutationObserver(scheduleLocalization).observe(document.body, { childList: true, subtree: true });
  });
})();
